import progress from 'nprogress'
import uniq from 'lodash/uniq'
import uniqBy from 'lodash/uniqBy'
import { db } from '@/core/shared'

export const getters = {
    dates: 'programs/dates',
    types: 'programs/types',
    items: 'programs/items',
    firstWave: 'programs/firstWave',
    secondWave: 'programs/secondWave'
}
export const mutations = {
    setItems: 'programs/setItems',
    setDate: 'programs/setDate',
    setType: 'programs/setType'
}
export const actions = {
    fetchItems: 'programs/fetchItems',
    setDate: 'programs/setDate'
}

export const store = {
    state: {
        items: [],
        date: null,
        type: null
    },
    getters: {
        [getters.dates]: (state) => {
            const months = []
            return uniqBy(
                state.items
                    .filter(x => x.date)
                    .reduce((acc, x) => {
                        const month = x.date.slice(5, 7)
                        if (months.indexOf(month) === -1) {
                            months.push(month)
                            acc.push({
                                label: parseInt(month) + '월',
                                value: x.date,
                                month: true
                            })
                        }
                        acc.push({
                            label: parseInt(x.date.slice(-2)),
                            value: x.date
                        })
                        return acc
                    }, [])
                , 'label'
            )
        },
        [getters.types]: (state) => {
            return uniq(state.items.map(x => x.type))
        },
        [getters.items]: (state) => {
            let items = state.items
            if (state.type) {
                items = items.filter(x => x.type === state.type)
            }
            if (state.date) {
                items = items.filter(x => x.date === state.date || ! x.date)
            }
            return items
        },
        [getters.firstWave]: (state) => {
            return uniqBy(
                state.items
                    .filter(x => ! x.secondWave)
                    .sort((a, b) => a.name > b.name ? 1 : -1),
                'name'
            )
        },
        [getters.secondWave]: (state) => {
            return uniqBy(
                state.items
                    .filter(x => x.secondWave)
                    .sort((a, b) => a.name > b.name ? 1 : -1),
                'name'
            )
        }
    },
    mutations: {
        [mutations.setItems]: (state, payload) => {
            state.items = payload
        },
        [mutations.setDate]: (state, payload) => {
            state.date = payload
        },
        [mutations.setType]: (state, payload) => {
            state.type = payload
        }
    },
    actions: {
        [actions.fetchItems]: async (context) => {
            if (context.state.items.length) {
                return
            }
            progress.start()
            const hasDateAsync = db.collection('programs')
                .where('date', '>', '')
                .orderBy('date')
                .orderBy('timeStart')
                .get()
            const noDateAsync = db.collection('programs')
                .where('date', '==', '')
                .orderBy('timeStart')
                .get()

            const hasDate = await hasDateAsync
            const noDate = await noDateAsync

            const items = hasDate.docs.concat(noDate.docs).map(x => ({
                id: x.id,
                ...x.data()
            }))
            progress.done()
            context.commit(mutations.setItems, items)
        },
        [actions.setDate]: async (context, payload) => {
            const dates = context.getters[getters.dates]
            const futures = dates.filter(x => ! x.month && x.value > payload)

            if (futures.length) {
                context.commit(mutations.setDate, futures[0].value)
            }
            else {
                context.commit(mutations.setDate, null)
            }
        }
    }
}